import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { CurrentUserService } from './services/current-user.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { SessionService } from './services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'fantasy';
  user_id: any;
  activePath: string;

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private permissionsService: NgxPermissionsService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private session: SessionService,
  ) {
    // A saved user whose login can't be renewed any more is signed out.
    this.session.checkOnStartup();
  }
  ngOnInit(): void {
    const perm = ['ADMIN'];

    this.permissionsService.loadPermissions(perm);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.activePath = this.router.url.split('/')[1];
        localStorage.setItem('activePath', this.activePath);
        if (!this.router.parseUrl(event.urlAfterRedirects).fragment) {
          this.scrollToTop();
          this.ngZone.onStable.pipe(take(1)).subscribe(() => this.scrollToTop());
        }
        if (event.url.includes('invitationpage') && !this.user_id) {
          // Invitation links: sign in first, then back to the invitation.
          this.router.navigate(['/login'], { queryParams: { returnTo: event.url } });
        }
      }
      if (event instanceof NavigationStart) {
        const previousPath = event.url;
        localStorage.setItem('previousPath', previousPath);
      }

    });
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = Number(data.id);
        this.cdr.detectChanges();
      }
    });
  }

  private scrollToTop(): void {
    const active = document.activeElement;
    if (active instanceof HTMLElement && active !== document.body) {
      active.blur();
    }
    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    html.scrollTop = 0;
    document.body.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    html.style.scrollBehavior = previousBehavior;
  }
}
